import React, {ReactElement} from "react"
import Bills, {BillsColumns} from "../../components/Bills/Bills"
import TitleBar from "../../components/TitleBar/TitleBar"
import {MainSectionTable} from "../../containers/MainSection/MainSection"
import {useIsBankUser, useIsUnitUser} from "../../services/auth"

export default function BillsPage(): ReactElement {
	return (
		<>
			<TitleBar title={"Bills"} />
			<MainSectionTable>
				<Bills
					enableOrgFilter={true}
					enableDateFilter={true}
					fullHeight={true}
					enableStatusFilter={true}
					includedColumns={[
						BillsColumns.id,
						...(useIsBankUser() || useIsUnitUser() ? [BillsColumns.org] : []),
						BillsColumns.customer,
						BillsColumns.invoiceNumber,
						BillsColumns.vendor,
						BillsColumns.amount,
						BillsColumns.status,
						BillsColumns.dueDate,
						BillsColumns.deductionDate,
						BillsColumns.createdAt,
					]}
				/>
			</MainSectionTable>
		</>
	)
}
